import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import { isEmpty } from "lodash";
import Button from "@material-ui/core/Button";
import styles from "../../assests/styles/layoutstyles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { withStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import {
  prospectFileUpload,
  campaignFileUpload,
  loadProspectFilesData,
  campaignFileTable,
} from "../../Redux/Actions/webAppActions";
const CustomSearchButton = withStyles({
  root: {
    backgroundColor: "#0089cf",
    borderColor: "#0089cf",
    "&:hover": {
      backgroundColor: "#0e4686",
      borderColor: "#0e4686",
      boxShadow: "none",
    },
  },
})(Button);
// Allowed extensions for input file
const allowedExtensions = ["csv"];

const CsvReader = (props) => {
  // This state will store the parsed data
  // const [data, setData] = useState([]);

  // It state will contain the error when
  // correct file extension is not usedcons

  // It will store the file uploaded by the user
  const [file, setFile] = useState("");
  const [csvFile, setcsvFile] = useState(true);
  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [alertMsg, setalertMsg] = useState("");
  const [severity, setseverity] = useState("");
  const [vertical, setvertical] = useState("top");
  const [horizontal, sethorizontal] = useState("center");
  const agentId = useSelector((state1) => state1.login.agentId);
  const agencyId = useSelector((state1) => state1.login.agencyIDSelected);
  const dispatch = useDispatch();
  // This function will be called when
  // the file input changes
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setsnackBarOpen(false);
  };
  const handleFileChange = (e) => {
    // Check if user has entered the file
    if (e.target.files.length) {
      const inputFile = e.target.files[0];
      let fileSize = (inputFile.size * 0.001) / 1024;
      //console.log("clsinputfile",fileSize)
      if (fileSize > 25) {
        document.getElementById("csvInput").value = "";
        setFile("");
        setsnackBarOpen(true);
        setalertMsg("Please upload a file having less than 25 MB size");
        setseverity("error");
        return;
      }
      // Check the file extensions, if it not
      // included in the allowed extensions
      // we show the error

      const fileExtension = inputFile?.type.split("/")[1];
      if (!allowedExtensions.includes(fileExtension)) {
        setcsvFile(false);
      }

      // If input type is correct set the state
      else {
        setcsvFile(true);
      }
      setFile(inputFile);
    }
  };
  const handleParse = () => {
    // If user clicks the parse button without
    // a file we show a error
    if (csvFile === true) {
      // // Initialize a reader which allows user
      // // to read any file or blob.
      // const reader = new FileReader();

      // // Event listener on reader when the file
      // // loads, we parse it and set the data.
      // reader.onload = async ({ target }) => {
      //   const csv = Papa.parse(target.result, { header: true });
      //   const parsedData = csv?.data;
      //   let csvdata = parsedData?.slice(0, -1);

      //   props.setData(csvdata);
      //   document.getElementById("csvInput").value = "";
      //   setFile("");
      //   // const columns = Object.keys(parsedData[0]);
      //   //setData(columns);
      // };
      // reader.readAsText(file);

      //callapi to upload  file
      const formData2 = new FormData();
      formData2.append("file", file);
      if (props.bulkUploadCampaign === true) {
        const campaignfileupload = dispatch(
          campaignFileUpload(formData2, "", "", agentId, agencyId)
        );
        campaignfileupload.then(function (value) {
          if (value?.status === "OK" || value?.data?.status === "OK") {
            setsnackBarOpen(true);
            setalertMsg("File Uploaded Successfully");
            setseverity("success");

            dispatch(campaignFileTable());
          } else {
            setsnackBarOpen(true);
            setseverity("error");
            if (value?.message || value?.data?.message) {
              setalertMsg(
                value?.message ? value?.message : value?.data?.message
              );
            } else {
              setalertMsg("System Error");
            }
          }
        });
      } else {
        formData2.append("planCampaignId", props?.planCampaignId);
        //const res=dispatch(prospectFileUpload(formData2,"","",agentId,agencyId))
        const res = dispatch(
          prospectFileUpload(
            formData2,
            "",
            "",
            props?.assignedToEventvalue,
            agencyId
          )
        );

        res.then(function (value) {
          if (value?.status === "OK" || value?.data?.status === "OK") {
            setsnackBarOpen(true);
            setalertMsg("File Uploaded Successfully");
            setseverity("success");

            dispatch(loadProspectFilesData());
          } else {
            setsnackBarOpen(true);
            setseverity("error");
            if (value?.message || value?.data?.message) {
              setalertMsg(
                value?.message ? value?.message : value?.data?.message
              );
            } else {
              setalertMsg("System Error");
            }
          }
        });
        // if(res?.status==="OK"){
        //   alert("hi")
        //    dispatch(loadProspectFilesData());
        // }
      }
      document.getElementById("csvInput").value = "";
      setFile("");
    } else {
      setsnackBarOpen(true);
      setalertMsg("Please upload a csv file");
      setseverity("error");
      setvertical("top");
      sethorizontal("center");
    }
  };
  useEffect(() => {
    return () => {
      document.getElementById("csvInput").value = "";
      setFile("");
    };
  }, [props.bulkUploadCampaign]);
  return (
    <div>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {alertMsg}
        </Alert>
      </Snackbar>
      <br />
      <input
        autoComplete="off"
        spellcheck="false"
        aria-autocomplete="both"
        aria-haspopup="false"
        onChange={handleFileChange}
        id="csvInput"
        name="file"
        type="File"
        disabled={props?.disabled}
      />
      <CustomSearchButton
        id="UploadBtn"
        variant="contained"
        size="small"
        style={{ marginTop: "5px" }}
        color="primary"
        // className={classes.button}
        onClick={handleParse}
        disabled={
          props.bulkUploadCampaign === false
            ? isEmpty(props?.assignedTo) ||
              props?.assignedTo === "---Select---" ||
              isEmpty(props?.planCampaignId) ||
              isEmpty(file.name)
            : isEmpty(file.name)
        }
      >
        Upload
      </CustomSearchButton>
    </div>
  );
};

export default CsvReader;
